// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   Tabs,
//   Tab,
//   Menu,
//   MenuItem,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Card,
//   CardContent,
//   CircularProgress,
//   Alert,
//   Button,
//   Chip
// } from "@mui/material";
// import { useLocation, useNavigate } from "react-router-dom";

// // Import therapy components
// import CaseHistoryAdult from "../components/CaseHistoryAdult";
// import CaseHistoryChild from "../components/CaseHistoryChild";
// import HearingEvaluationAdult from "../components/HearingEvaluationAdult";
// import HearingEvaluationChild from "../components/HearingEvaluationChild";
// import HearingAidTraining from "../components/HearingAidTraining";
// import ProcuringHearingAid from "../components/ProcuringHearingAid";
// import HearingFollow from "../components/HearingFollow";
// import ListeningTrainingUnit from "../components/ListeningTrainingUnit";
// import OutReach from "../components/OutReach";
// import SchoolScreeningForm from "../components/SchoolScreeningForm";
// import Hypercusis from "../components/Hypercusis";
// import Tinnitus from "../components/Tinnitus";
// import VestibularForm from "../components/VestibularForm";
// import HearingWellness from "../components/HearingWelness";
// import NewbornForm from "../components/NewbornForm";
// import Cochlear from "../components/Cochlear";
// import Demographic from "../components/Demographic";
// import IntraOp from "../components/IntraOp";
// import SwitchOn from "../components/SwitchOn";
// import Mapping from "../components/Mapping";
// import OutCome from "../components/OutCome";
// import PrenatalHistory from "../components/PrenatalHistory";
// import PrenatalTest from "../components/PrenatalTest";
// import TherapyAllotment from "../components/TherapyAllotment";
// import VideoUploaded from "../components/VideoUploaded";
// import ReportSubmission from "../components/ReportSubmission";
// import CorrectedReportSupervisor from "../components/CorrectedReportSupervisor";
// import PaymentForm from "../components/PaymentForm";

// const Demography = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [patientData, setPatientData] = useState(null);
//   const [patientForms, setPatientForms] = useState([]);
//   const [error, setError] = useState("");
//   const [department, setDepartment] = useState("");
//   const [selectedForm, setSelectedForm] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [currentDropdown, setCurrentDropdown] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [formsLoading, setFormsLoading] = useState(false);

//   useEffect(() => {
//     // Get department from localStorage
//     const savedDepartment = localStorage.getItem("department");
//     if (savedDepartment) {
//       setDepartment(savedDepartment);
//       if (["Outreach", "GHWC", "School Screening", "NBHS","Payment"].includes(savedDepartment)) {
//         handleFormSelect(savedDepartment);
//       }
//     }

//     // Fetch patient data
//     fetchPatientData();
//   }, []);

//   const fetchPatientData = async () => {
//     try {
//       setLoading(true);
//       setError("");
      
//       // Get patient data from localStorage (set during registration or revisit)
//       const savedPatientData = localStorage.getItem('demography');
      
//       if (!savedPatientData) {
//         // If no patient data in localStorage, check if we have a patient ID from revisit
//         const revisitPatientId = localStorage.getItem('revisitPatientId');
//         if (revisitPatientId) {
//           await fetchPatientById(revisitPatientId);
//         } else {
//           setError("No patient data found. Please register or revisit a patient first.");
//           setLoading(false);
//         }
//         return;
//       }

//       const patient = JSON.parse(savedPatientData);
//       console.log("📄 Patient data from localStorage:", patient);
//       setPatientData(patient);

//       // Fetch forms for this patient
//       if (patient.id) {
//         await fetchPatientForms(patient.id);
//       }
      
//     } catch (error) {
//       console.error('Error fetching patient data:', error);
//       setError("Failed to load patient data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPatientById = async (patientId) => {
//     try {
//       console.log("🔄 Fetching patient by ID:", patientId);
      
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patients/${patientId}`);
      
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: Failed to fetch patient data`);
//       }
      
//       const patient = await response.json();
//       console.log("📄 Patient data from API:", patient);
      
//       // Save to localStorage for consistency
//       localStorage.setItem('demography', JSON.stringify(patient));
//       setPatientData(patient);

//       // Fetch forms for this patient
//       await fetchPatientForms(patient.id);
      
//     } catch (error) {
//       console.error('❌ Error fetching patient:', error);
//       setError("Failed to load patient data: " + error.message);
//     }
//   };

// const fetchPatientForms = async (patientId) => {
//   try {
//     setFormsLoading(true);
//     console.log("🔄 Fetching forms for patient ID:", patientId);
    
//     // Validate patient ID
//     if (!patientId) {
//       console.error("❌ No patient ID provided");
//       setPatientForms([]);
//       return;
//     }
    
//     // Try to fetch forms from the API
//     const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patient-forms/${patientId}`);
    
//     console.log("📊 Response status:", response.status, response.statusText);
    
//     if (!response.ok) {
//       // Try to get more details from the response
//       let errorDetails = '';
//       try {
//         const errorData = await response.json();
//         errorDetails = JSON.stringify(errorData);
//       } catch {
//         errorDetails = await response.text();
//       }
      
//       console.error(`❌ Server error ${response.status}:`, errorDetails);
      
//       // For now, set empty array and show error in console
//       setPatientForms([]);
      
//       // You might want to show this in UI too
//       console.error("Backend API error. Please check:");
//       console.error("1. Is the server running on port 5000?");
//       console.error("2. Does the endpoint /api/patient-forms/:patientId exist?");
//       console.error("3. Check server logs for detailed error.");
//       return;
//     }
    
//     const forms = await response.json();
//     console.log("📋 Forms received from API:", forms);
//     console.log("📋 Number of forms:", forms.length);
    
//     // Ensure forms is an array
//     setPatientForms(Array.isArray(forms) ? forms : []);
    
//   } catch (error) {
//     console.error('❌ Network error fetching patient forms:', error);
//     console.error("This is a network error. Check:");
//     console.error("1. Is the backend server running?");
//     console.error("2. Is there a CORS issue?");
//     console.error("3. Check browser console for CORS errors");
    
//     setPatientForms([]);
//   } finally {
//     setFormsLoading(false);
//   }
// };

//   const handleFormSelect = (formName) => {
//     // Create form with patient data
//     const createFormWithPatientData = (Component) => {
//       return React.createElement(Component, { patientData });
//     };

//     switch (formName) {
//       case "Outreach": 
//         setSelectedForm(createFormWithPatientData(OutReach)); 
//         break;
//       case "School Screening": 
//         setSelectedForm(createFormWithPatientData(SchoolScreeningForm)); 
//         break;
//       case "GHWC": 
//         setSelectedForm(createFormWithPatientData(HearingWellness)); 
//         break;
//       case "NBHS": 
//         setSelectedForm(createFormWithPatientData(NewbornForm)); 
//         break;
//       case "Tinnitus": 
//         setSelectedForm(createFormWithPatientData(Tinnitus)); 
//         break;
//       case "LTU": 
//         setSelectedForm(createFormWithPatientData(ListeningTrainingUnit)); 
//         break;
//       case "Hypercusis": 
//         setSelectedForm(createFormWithPatientData(Hypercusis)); 
//         break;
//       case "Vestibular Assessment": 
//         setSelectedForm(createFormWithPatientData(VestibularForm)); 
//         break;
//       case "Cochlear": 
//         setSelectedForm(createFormWithPatientData(Cochlear)); 
//         break;
//         case "Payment":
//         setSelectedForm(createFormWithPatientData(PaymentForm));
//         break
//       default: 
//         setSelectedForm(null);
//     }
//   };

//   const handleOptionSelect = (option) => {
//     // Create form component with patient data
//     const formWithPatientData = React.cloneElement(option.component, { patientData });
//     setSelectedForm(formWithPatientData);
//     setAnchorEl(null);
//     setCurrentDropdown(null);
//   };

//   const handleDropdownOpen = (event, dropdown) => {
//     setAnchorEl(event.currentTarget);
//     setCurrentDropdown(dropdown);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setCurrentDropdown(null);
//   };

//   const getFormLabel = (formType) => {
//     const formLabels = {
//       'CaseHistoryAdult': 'Case History (Adult)',
//       'CaseHistoryChild': 'Case History (Child)',
//       'Tinnitus': 'Tinnitus',
//       'Hyperacusis': 'Hyperacusis',
//       'ListeningTrainingUnit': 'Listening Training Unit',
//       'HearingEvaluationAdult': 'Hearing Evaluation (Adult)',
//       'HearingEvaluationChild': 'Hearing Evaluation (Child)',
//       'HearingAidTraining': 'Hearing Aid Training',
//       'ProcuringHearingAid': 'Procuring Hearing Aid',
//       'HearingFollow': 'Hearing Follow-up',
//       'Outreach': 'Outreach',
//       'SchoolScreening': 'School Screening',
//       'HearingWellness': 'Hearing Wellness',
//       'Newborn': 'Newborn Screening',
//       'Vestibular': 'Vestibular Assessment',
//       'Demographic': 'Demographic',
//       'Intraoperative': 'Intraoperative',
//       'Switchon': 'Switch On',
//       'Mapping': 'Mapping',
//       'Outcome': 'Outcome',
//       'PrenatalHistory': 'Prenatal History',
//       'PrenatalTests': 'Prenatal Tests',
//       'TherapyAllotment': 'Therapy Allotment',
//       'VideoUploaded': 'Video Upload',
//       'ReportSubmission': 'Report Submission',
//       'CorrectedReportSupervisor': 'Corrected Report',
//       'PaymentForm': 'Payment Form'
//     };
    
//     return formLabels[formType] || formType;
//   };

//   const loadPreviousForm = async (form) => {
//     try {
//       setFormsLoading(true);
      
//       let formComponent = null;
      
//       switch (form.form_type) {
//         case 'CaseHistoryAdult':
//           formComponent = <CaseHistoryAdult data={form.data} patientData={patientData} />;
//           break;
//         case 'CaseHistoryChild':
//           formComponent = <CaseHistoryChild data={form.data} patientData={patientData} />;
//           break;
//         case 'Tinnitus':
//           formComponent = <Tinnitus data={form.data} patientData={patientData} />;
//           break;
//         case 'Hyperacusis':
//           formComponent = <Hypercusis data={form.data} patientData={patientData} />;
//           break;
//         case 'ListeningTrainingUnit':
//           formComponent = <ListeningTrainingUnit data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingEvaluationAdult':
//           formComponent = <HearingEvaluationAdult data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingEvaluationChild':
//           formComponent = <HearingEvaluationChild data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingAidTraining':
//           formComponent = <HearingAidTraining data={form.data} patientData={patientData} />;
//           break;
//         case 'ProcuringHearingAid':
//           formComponent = <ProcuringHearingAid data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingFollow':
//           formComponent = <HearingFollow data={form.data} patientData={patientData} />;
//           break;
//         case 'Outreach':
//           formComponent = <OutReach data={form.data} patientData={patientData} />;
//           break;
//         case 'SchoolScreening':
//           formComponent = <SchoolScreeningForm data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingWellness':
//           formComponent = <HearingWellness data={form.data} patientData={patientData} />;
//           break;
//         case 'Newborn':
//           formComponent = <NewbornForm data={form.data} patientData={patientData} />;
//           break;
//         case 'Vestibular':
//           formComponent = <VestibularForm data={form.data} patientData={patientData} />;
//           break;
//         case 'Demographic':
//           formComponent = <Demographic data={form.data} patientData={patientData} />;
//           break;
//         case 'Intraoperative':
//           formComponent = <IntraOp data={form.data} patientData={patientData} />;
//           break;
//         case 'Switchon':
//           formComponent = <SwitchOn data={form.data} patientData={patientData} />;
//           break;
//         case 'Mapping':
//           formComponent = <Mapping data={form.data} patientData={patientData} />;
//           break;
//         case 'Outcome':
//           formComponent = <OutCome data={form.data} patientData={patientData} />;
//           break;
//         case 'PrenatalHistory':
//           formComponent = <PrenatalHistory data={form.data} patientData={patientData} />;
//           break;
//         case 'PrenatalTests':
//           formComponent = <PrenatalTest data={form.data} patientData={patientData} />;
//           break;
//         case 'TherapyAllotment':
//           formComponent = <TherapyAllotment data={form.data} patientData={patientData} />;
//           break;
//         case 'VideoUploaded':
//           formComponent = <VideoUploaded data={form.data} patientData={patientData} />;
//           break;
//         case 'ReportSubmission':
//           formComponent = <ReportSubmission data={form.data} patientData={patientData} />;
//           break;
//         case 'CorrectedReportSupervisor':
//           formComponent = <CorrectedReportSupervisor data={form.data} patientData={patientData} />;
//           break;
//           case 'PaymentForm':
//             formComponent = <PaymentForm data={form.data} patientData={patientData} />;
//             break;
//         default:
//           formComponent = <Alert severity="warning">Form type "{form.form_type}" not supported for editing</Alert>;
//       }
      
//       setSelectedForm(formComponent);
//     } catch (error) {
//       console.error('Error loading previous form:', error);
//       setError('Failed to load form data');
//     } finally {
//       setFormsLoading(false);
//     }
//   };

//   const handleBackToRegister = () => {
//     navigate('/register');
//   };

//   const refreshForms = () => {
//     if (patientData?.id) {
//       fetchPatientForms(patientData.id);
//     }
//   };

//   const therapyButtons = {
//     Audiology: [
//       {
//         label: "Case History", 
//         type: "dropdown", 
//         options: [
//           { label: "Adult", component: <CaseHistoryAdult patientData={patientData} /> },
//           { label: "Child", component: <CaseHistoryChild patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Hearing Evaluation", 
//         type: "dropdown", 
//         options: [
//           { label: "Adult", component: <HearingEvaluationAdult patientData={patientData} /> },
//           { label: "Child", component: <HearingEvaluationChild patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Hearing Aid", 
//         type: "dropdown", 
//         options: [
//           { label: "Hearing Aid Trial", component: <HearingAidTraining patientData={patientData} /> },
//           { label: "Hearing Aid Programming", component: <ProcuringHearingAid patientData={patientData} /> },
//           { label: "Hearing Aid Followup", component: <HearingFollow patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Cochlear Implant", 
//         type: "dropdown", 
//         options: [
//           { label: "Demographic", component: <Demographic patientData={patientData} /> },
//           { label: "IntraOp", component: <IntraOp patientData={patientData} /> },
//           { label: "Switch on", component: <SwitchOn patientData={patientData} /> },
//           { label: "Mapping", component: <Mapping patientData={patientData} /> },
//           { label: "Outcome", component: <OutCome patientData={patientData} /> }
//         ]
//       },
//       { 
//         label: "Prenatal", 
//         type: "dropdown", 
//         options: [
//           { label: "Prenatal History", component: <PrenatalHistory patientData={patientData} /> },
//           { label: "Prenatal Tests", component: <PrenatalTest patientData={patientData} /> },
//         ]
//       },
//       { 
//         label: "Tinnitus", 
//         type: "flat", 
//         component: <Tinnitus patientData={patientData} /> 
//       },
//       { 
//         label: "LTU", 
//         type: "dropdown", 
//         options: [
//           { label: "Therapy Allotment", component: <TherapyAllotment patientData={patientData} /> },
//           { label: "Video Uploaded", component: <VideoUploaded patientData={patientData} /> },
//           { label: "Report Submission", component: <ReportSubmission patientData={patientData} /> },
//           { label: "Corrected Report Supervisor", component: <CorrectedReportSupervisor patientData={patientData} /> },
//         ]
//       },
//       { 
//         label: "Hypercusis", 
//         type: "flat", 
//         component: <Hypercusis patientData={patientData} /> 
//       },
//       { 
//         label: "Vestibular Assessment", 
//         type: "flat", 
//         component: <VestibularForm patientData={patientData} /> 
//       }
//     ],
//     Speech: [
//       { label: "Case History", type: "flat", component: <CaseHistoryAdult patientData={patientData} /> },
//       { label: "Evaluation", type: "flat", component: <div>Evaluation Form</div> },
//       { label: "Therapy", type: "flat", component: <div>Therapy Form</div> },
//       { label: "Follow Up", type: "flat", component: <div>Follow Up Form</div> },
//     ]
//   };

//   const nonTherapyDepartments = ["Outreach", "GHWC", "School Screening", "NBHS","Payment"];
  
//   // Check if department is internal (Audiology or Speech)
//   const isInternalDepartment = ["Audiology", "Speech"].includes(department);
//   // Check if department is non-therapy (outside forms)
//   const isNonTherapyDepartment = nonTherapyDepartments.includes(department);

//   // If no patient data found, show error and option to go back
//   if (!patientData && !loading) {
//     return (
//       <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
//         <Alert 
//           severity="error" 
//           action={
//             <Button color="inherit" size="small" onClick={handleBackToRegister}>
//               Go to Registration
//             </Button>
//           }
//         >
//           No patient data found. Please register or revisit a patient first.
//         </Alert>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xxl" sx={{ mt: 3, mb: 4 }}>
//       {error && (
//         <Alert severity="error" sx={{ mb: 2 }}>
//           {error}
//         </Alert>
//       )}
      
//       <Paper elevation={3} sx={{ display: "flex", minHeight: 600, p: 3 }}>
//         {/* Left Panel - Inventory - ONLY SHOW FOR INTERNAL DEPARTMENTS */}
// {isInternalDepartment && (
//   <Box sx={{ width: 350, pr: 3, borderRight: "1px solid #ccc" }}>
//     <Card elevation={1} sx={{ bgcolor: "#f9fafc", borderRadius: 2 }}>
//       <CardContent>
//         <Typography variant="h6" sx={{ mb: 2, color: "#0d1b2a" }}>
//           Patient Record
//         </Typography>

//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : patientData ? (
//           <>
//             {/* Clinic Number Display */}
//             <Box sx={{ mb: 2, p: 1.5, bgcolor: '#e8f4fd', borderRadius: 1 }}>
//               <Typography variant="subtitle2" color="primary" gutterBottom>
//                 Clinic Number
//               </Typography>
//               <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                 {patientData.ip_number || patientData.op_number || "Not Assigned"}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {patientData.ip_number ? "IP Number" : "OP Number"}
//               </Typography>
//             </Box>
            
//             {/* Patient Information */}
//             <Box sx={{ mt: 2, mb: 3 }}>
//               <Typography variant="subtitle2" sx={{ mb: 1, color: "#0d1b2a" }}>
//                 Patient Information
//               </Typography>
//               <Box sx={{ display: 'grid', gap: 1 }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <Typography variant="body2" color="text.secondary">Name:</Typography>
//                   <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                     {patientData.name || "N/A"}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <Typography variant="body2" color="text.secondary">Age:</Typography>
//                   <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                     {patientData.age || "N/A"}
//                   </Typography>
//                 </Box>
            
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                   <Typography variant="body2" color="text.secondary">Phone:</Typography>
//                   <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                     {patientData.phone || "N/A"}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Forms Section */}
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, mb: 1 }}>
//               <Typography variant="subtitle2" sx={{ color: "#0d1b2a" }}>
//                 Clinical Forms
//               </Typography>
//               <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                 <Chip 
//                   label={`${patientForms.length} forms`} 
//                   size="small" 
//                   color={patientForms.length > 0 ? "primary" : "default"}
//                   variant="outlined"
//                 />
//                 <Button 
//                   size="small" 
//                   onClick={refreshForms} 
//                   disabled={formsLoading}
//                   variant="outlined"
//                 >
//                   {formsLoading ? <CircularProgress size={16} /> : 'Refresh'}
//                 </Button>
//               </Box>
//             </Box>
            
//             {formsLoading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
//                 <CircularProgress size={24} />
//               </Box>
//             ) : (
//               <>
//                 {patientForms.length > 0 ? (
//                   <Paper variant="outlined" sx={{ maxHeight: 300, overflow: 'auto' }}>
//                     <List dense>
//                       {patientForms.map((form, index) => (
//                         <ListItem 
//                           key={index} 
//                           button 
//                           onClick={() => loadPreviousForm(form)}
//                           sx={{ 
//                             mb: 0.5, 
//                             borderRadius: 1,
//                             borderLeft: '3px solid',
//                             borderLeftColor: 'primary.main',
//                             '&:hover': { 
//                               backgroundColor: '#e3f2fd',
//                               transform: 'translateX(2px)'
//                             },
//                             transition: 'all 0.2s'
//                           }}
//                         >
//                           <ListItemText
//                             primary={
//                               <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                                 {getFormLabel(form.form_type)}
//                               </Typography>
//                             }
//                             secondary={
//                               <Typography variant="caption" color="text.secondary">
//                                 {new Date(form.created_at).toLocaleDateString()} • 
//                                 {new Date(form.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//                               </Typography>
//                             }
//                           />
//                         </ListItem>
//                       ))}
//                     </List>
//                   </Paper>
//                 ) : (
//                   <Box sx={{ 
//                     textAlign: 'center', 
//                     py: 3, 
//                     border: '1px dashed #ddd', 
//                     borderRadius: 1,
//                     bgcolor: '#fafafa'
//                   }}>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                       No forms submitted yet for this patient
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
//                       Start by selecting a form from the menu
//                     </Typography>
//                     <Button 
//                       variant="outlined" 
//                       size="small" 
//                       onClick={() => {
//                         // Select the first form in the menu
//                         const firstTab = therapyButtons[department]?.[0];
//                         if (firstTab) {
//                           if (firstTab.type === "dropdown") {
//                             // Handle dropdown forms
//                             if (firstTab.options?.[0]) {
//                               handleOptionSelect(firstTab.options[0]);
//                             }
//                           } else {
//                             setSelectedForm(React.cloneElement(firstTab.component, { patientData }));
//                           }
//                         }
//                       }}
//                       sx={{ mt: 1 }}
//                     >
//                       Start New Form
//                     </Button>
//                   </Box>
//                 )}
//               </>
//             )}
            
//             {/* Debug Info */}
//             <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #eee' }}>
//               <Typography variant="caption" color="text.secondary">
//                 Patient ID: {patientData.id || "N/A"}
//               </Typography>
//               <br />
//               <Typography variant="caption" color="text.secondary">
//                 Clinic No: {patientData.ip_number || patientData.op_number || "Not Assigned"}
//               </Typography>
//             </Box>
//           </>
//         ) : (
//           <Box sx={{ textAlign: 'center', py: 4 }}>
//             <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//               No patient data available
//             </Typography>
//             <Button 
//               variant="contained" 
//               size="small" 
//               onClick={handleBackToRegister}
//             >
//               Register Patient
//             </Button>
//           </Box>
//         )}
//       </CardContent>
//     </Card>
//   </Box>
// )}

//         {/* Right Panel - Form Display */}
//         <Box sx={{ 
//           flexGrow: 1, 
//           pl: isInternalDepartment ? 3 : 0,
//           width: isNonTherapyDepartment ? '100%' : 'auto' 
//         }}>
//           <Typography variant="h4" align="center" sx={{ mb: 2, color: "primary.main" }}>
//             {patientData ? `Clinical Forms` : 'Clinical Forms'}
//           </Typography>

//           {isNonTherapyDepartment && selectedForm && (
//             <Box sx={{ width: '100%' }}>
//               {formsLoading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
//                   <CircularProgress />
//                 </Box>
//               ) : (
//                 selectedForm
//               )}
//             </Box>
//           )}

//           {isInternalDepartment && patientData && (
//             <>
//               <Tabs
//                 value={activeTab}
//                 onChange={(e, newValue) => setActiveTab(newValue)}
//                 variant="scrollable"
//                 scrollButtons="auto"
//                 sx={{ mb: 2 }}
//               >
//                 {therapyButtons[department]?.map((button, index) => (
//                   <Tab
//                     key={index}
//                     label={button.label}
//                     onClick={(e) => {
//                       if (button.type === "dropdown") {
//                         handleDropdownOpen(e, button);
//                       } else {
//                         setSelectedForm(React.cloneElement(button.component, { patientData }));
//                       }
//                     }}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       mx: 1,
//                       px: 3,
//                       borderRadius: "30px",
//                       backgroundColor: activeTab === index ? "#0d1b2a" : "#e8ecf1",
//                       color: activeTab === index ? "#ffffff" : "#0d1b2a",
//                       "&:hover": {
//                         backgroundColor: "#16293f",
//                         color: "#ffffff",
//                       },
//                     }} 
//                   />
//                 ))}
//               </Tabs>
 
//               <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
//                 {currentDropdown?.options?.map((option, idx) => (
//                   <MenuItem key={idx} onClick={() => handleOptionSelect(option)}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Menu>
 
//               <Box sx={{ mt: 2, border: "1px solid #e0e0e0", borderRadius: 2, p: 3, minHeight: 520,width: '93%' }}>
//                 {formsLoading ? (
//                   <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
//                     <CircularProgress />
//                   </Box>
//                 ) : selectedForm ? (
//                   selectedForm
//                 ) : (
//                   <Typography variant="body1" align="center" sx={{ color: "text.secondary", mt: 8 }}>
//                     Select a form from the menu above to begin
//                   </Typography>
//                 )}
//               </Box>
//             </>
//           )}

//           {!isInternalDepartment && !isNonTherapyDepartment && patientData && (
//             <Box sx={{ textAlign: 'center', mt: 8 }}>
//               <Typography variant="h6" color="text.secondary">
//                 No department selected or department not recognized
//               </Typography>
//               <Button 
//                 variant="contained" 
//                 onClick={handleBackToRegister}
//                 sx={{ mt: 2 }}
//               >
//                 Select Department
//               </Button>
//             </Box>
//           )}
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default Demography;


// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   Tabs,
//   Tab,
//   Menu,
//   MenuItem,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Card,
//   CardContent,
//   CircularProgress,
//   Alert,
//   Button,
//   Chip
// } from "@mui/material";
// import { useLocation, useNavigate } from "react-router-dom";

// // Import therapy components
// import CaseHistoryAdult from "../components/CaseHistoryAdult";
// import CaseHistoryChild from "../components/CaseHistoryChild";
// import HearingEvaluationAdult from "../components/HearingEvaluationAdult";
// import HearingEvaluationChild from "../components/HearingEvaluationChild";
// import HearingAidTraining from "../components/HearingAidTraining";
// import ProcuringHearingAid from "../components/ProcuringHearingAid";
// import HearingFollow from "../components/HearingFollow";
// import ListeningTrainingUnit from "../components/ListeningTrainingUnit";
// import OutReach from "../components/OutReach";
// import SchoolScreeningForm from "../components/SchoolScreeningForm";
// import Hypercusis from "../components/Hypercusis";
// import Tinnitus from "../components/Tinnitus";
// import VestibularForm from "../components/VestibularForm";
// import HearingWellness from "../components/HearingWelness";
// import NewbornForm from "../components/NewbornForm";
// import Cochlear from "../components/Cochlear";
// import Demographic from "../components/Demographic";
// import IntraOp from "../components/IntraOp";
// import SwitchOn from "../components/SwitchOn";
// import Mapping from "../components/Mapping";
// import OutCome from "../components/OutCome";
// import PrenatalHistory from "../components/PrenatalHistory";
// import PrenatalTest from "../components/PrenatalTest";
// import TherapyAllotment from "../components/TherapyAllotment";
// import VideoUploaded from "../components/VideoUploaded";
// import ReportSubmission from "../components/ReportSubmission";
// import CorrectedReportSupervisor from "../components/CorrectedReportSupervisor";
// import PaymentForm from "../components/PaymentForm";

// const Demography = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [patientData, setPatientData] = useState(null);
//   const [patientForms, setPatientForms] = useState([]);
//   const [error, setError] = useState("");
//   const [department, setDepartment] = useState("");
//   const [selectedForm, setSelectedForm] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [currentDropdown, setCurrentDropdown] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [formsLoading, setFormsLoading] = useState(false);

//   useEffect(() => {
//     // Get department from localStorage
//     const savedDepartment = localStorage.getItem("department");
//     if (savedDepartment) {
//       setDepartment(savedDepartment);
//       if (["Outreach", "GHWC", "School Screening", "NBHS", "Payment"].includes(savedDepartment)) {
//         handleFormSelect(savedDepartment);
//       }
//     }

//     // Fetch patient data
//     fetchPatientData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const fetchPatientData = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       // Get patient data from localStorage (set during registration or revisit)
//       const savedPatientData = localStorage.getItem("demography");

//       if (!savedPatientData) {
//         // If no patient data in localStorage, check if we have a patient ID from revisit
//         const revisitPatientId = localStorage.getItem("revisitPatientId");
//         if (revisitPatientId) {
//           await fetchPatientById(revisitPatientId);
//         } else {
//           setError("No patient data found. Please register or revisit a patient first.");
//           setLoading(false);
//         }
//         return;
//       }

//       const patient = JSON.parse(savedPatientData);
//       console.log("📄 Patient data from localStorage:", patient);
//       setPatientData(patient);

//       // Fetch forms for this patient
//       if (patient.id) {
//         await fetchPatientForms(patient.id);
//       }

//     } catch (error) {
//       console.error('Error fetching patient data:', error);
//       setError("Failed to load patient data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPatientById = async (patientId) => {
//     try {
//       console.log("🔄 Fetching patient by ID:", patientId);

//       const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patients/${patientId}`);

//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: Failed to fetch patient data`);
//       }

//       const patient = await response.json();
//       console.log("📄 Patient data from API:", patient);

//       // Save to localStorage for consistency
//       localStorage.setItem('demography', JSON.stringify(patient));
//       setPatientData(patient);

//       // Fetch forms for this patient
//       await fetchPatientForms(patient.id);

//     } catch (error) {
//       console.error('❌ Error fetching patient:', error);
//       setError("Failed to load patient data: " + error.message);
//     }
//   };

//   const fetchPatientForms = async (patientId) => {
//     try {
//       setFormsLoading(true);
//       console.log("🔄 Fetching forms for patient ID:", patientId);

//       // Validate patient ID
//       if (!patientId) {
//         console.error("❌ No patient ID provided");
//         setPatientForms([]);
//         return;
//       }

//       // Try to fetch forms from the API
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patient-forms/${patientId}`);

//       console.log("📊 Response status:", response.status, response.statusText);

//       if (!response.ok) {
//         // Try to get more details from the response
//         let errorDetails = '';
//         try {
//           const errorData = await response.json();
//           errorDetails = JSON.stringify(errorData);
//         } catch {
//           errorDetails = await response.text();
//         }

//         console.error(`❌ Server error ${response.status}:`, errorDetails);

//         // For now, set empty array and show error in console
//         setPatientForms([]);

//         // You might want to show this in UI too
//         console.error("Backend API error. Please check:");
//         console.error("1. Is the server running on port 5000?");
//         console.error("2. Does the endpoint /api/patient-forms/:patientId exist?");
//         console.error("3. Check server logs for detailed error.");
//         return;
//       }

//       const forms = await response.json();
//       console.log("📋 Forms received from API:", forms);
//       console.log("📋 Number of forms:", forms.length);

//       // Ensure forms is an array
//       setPatientForms(Array.isArray(forms) ? forms : []);

//     } catch (error) {
//       console.error('❌ Network error fetching patient forms:', error);
//       console.error("This is a network error. Check:");
//       console.error("1. Is the backend server running?");
//       console.error("2. Is there a CORS issue?");
//       console.error("3. Check browser console for CORS errors");

//       setPatientForms([]);
//     } finally {
//       setFormsLoading(false);
//     }
//   };

//   const handleFormSelect = (formName) => {
//     // Create form with patient data
//     const createFormWithPatientData = (Component) => {
//       return React.createElement(Component, { patientData });
//     };

//     switch (formName) {
//       case "Outreach":
//         setSelectedForm(createFormWithPatientData(OutReach));
//         break;
//       case "School Screening":
//         setSelectedForm(createFormWithPatientData(SchoolScreeningForm));
//         break;
//       case "GHWC":
//         setSelectedForm(createFormWithPatientData(HearingWellness));
//         break;
//       case "NBHS":
//         setSelectedForm(createFormWithPatientData(NewbornForm));
//         break;
//       case "Tinnitus":
//         setSelectedForm(createFormWithPatientData(Tinnitus));
//         break;
//       case "LTU":
//         setSelectedForm(createFormWithPatientData(ListeningTrainingUnit));
//         break;
//       case "Hypercusis":
//         setSelectedForm(createFormWithPatientData(Hypercusis));
//         break;
//       case "Vestibular Assessment":
//         setSelectedForm(createFormWithPatientData(VestibularForm));
//         break;
//       case "Cochlear":
//         setSelectedForm(createFormWithPatientData(Cochlear));
//         break;
//       case "Payment":
//         // fixed: added break so default doesn't overwrite
//         setSelectedForm(createFormWithPatientData(PaymentForm));
//         break;
//       default:
//         setSelectedForm(null);
//     }
//   };

//   const handleOptionSelect = (option) => {
//     // Create form component with patient data
//     const formWithPatientData = React.cloneElement(option.component, { patientData });
//     setSelectedForm(formWithPatientData);
//     setAnchorEl(null);
//     setCurrentDropdown(null);
//   };

//   const handleDropdownOpen = (event, dropdown) => {
//     setAnchorEl(event.currentTarget);
//     setCurrentDropdown(dropdown);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setCurrentDropdown(null);
//   };

//   const getFormLabel = (formType) => {
//     const formLabels = {
//       'CaseHistoryAdult': 'Case History (Adult)',
//       'CaseHistoryChild': 'Case History (Child)',
//       'Tinnitus': 'Tinnitus',
//       'Hyperacusis': 'Hyperacusis',
//       'ListeningTrainingUnit': 'Listening Training Unit',
//       'HearingEvaluationAdult': 'Hearing Evaluation (Adult)',
//       'HearingEvaluationChild': 'Hearing Evaluation (Child)',
//       'HearingAidTraining': 'Hearing Aid Training',
//       'ProcuringHearingAid': 'Procuring Hearing Aid',
//       'HearingFollow': 'Hearing Follow-up',
//       'Outreach': 'Outreach',
//       'SchoolScreening': 'School Screening',
//       'HearingWellness': 'Hearing Wellness',
//       'Newborn': 'Newborn Screening',
//       'Vestibular': 'Vestibular Assessment',
//       'Demographic': 'Demographic',
//       'Intraoperative': 'Intraoperative',
//       'Switchon': 'Switch On',
//       'Mapping': 'Mapping',
//       'Outcome': 'Outcome',
//       'PrenatalHistory': 'Prenatal History',
//       'PrenatalTests': 'Prenatal Tests',
//       'TherapyAllotment': 'Therapy Allotment',
//       'VideoUploaded': 'Video Upload',
//       'ReportSubmission': 'Report Submission',
//       'CorrectedReportSupervisor': 'Corrected Report',
//       'PaymentForm': 'Payment Form'
//     };

//     return formLabels[formType] || formType;
//   };

//   const loadPreviousForm = async (form) => {
//     try {
//       setFormsLoading(true);

//       let formComponent = null;

//       switch (form.form_type) {
//         case 'CaseHistoryAdult':
//           formComponent = <CaseHistoryAdult data={form.data} patientData={patientData} />;
//           break;
//         case 'CaseHistoryChild':
//           formComponent = <CaseHistoryChild data={form.data} patientData={patientData} />;
//           break;
//         case 'Tinnitus':
//           formComponent = <Tinnitus data={form.data} patientData={patientData} />;
//           break;
//         case 'Hyperacusis':
//           formComponent = <Hypercusis data={form.data} patientData={patientData} />;
//           break;
//         case 'ListeningTrainingUnit':
//           formComponent = <ListeningTrainingUnit data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingEvaluationAdult':
//           formComponent = <HearingEvaluationAdult data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingEvaluationChild':
//           formComponent = <HearingEvaluationChild data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingAidTraining':
//           formComponent = <HearingAidTraining data={form.data} patientData={patientData} />;
//           break;
//         case 'ProcuringHearingAid':
//           formComponent = <ProcuringHearingAid data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingFollow':
//           formComponent = <HearingFollow data={form.data} patientData={patientData} />;
//           break;
//         case 'Outreach':
//           formComponent = <OutReach data={form.data} patientData={patientData} />;
//           break;
//         case 'SchoolScreening':
//           formComponent = <SchoolScreeningForm data={form.data} patientData={patientData} />;
//           break;
//         case 'HearingWellness':
//           formComponent = <HearingWellness data={form.data} patientData={patientData} />;
//           break;
//         case 'Newborn':
//           formComponent = <NewbornForm data={form.data} patientData={patientData} />;
//           break;
//         case 'Vestibular':
//           formComponent = <VestibularForm data={form.data} patientData={patientData} />;
//           break;
//         case 'Demographic':
//           formComponent = <Demographic data={form.data} patientData={patientData} />;
//           break;
//         case 'Intraoperative':
//           formComponent = <IntraOp data={form.data} patientData={patientData} />;
//           break;
//         case 'Switchon':
//           formComponent = <SwitchOn data={form.data} patientData={patientData} />;
//           break;
//         case 'Mapping':
//           formComponent = <Mapping data={form.data} patientData={patientData} />;
//           break;
//         case 'Outcome':
//           formComponent = <OutCome data={form.data} patientData={patientData} />;
//           break;
//         case 'PrenatalHistory':
//           formComponent = <PrenatalHistory data={form.data} patientData={patientData} />;
//           break;
//         case 'PrenatalTests':
//           formComponent = <PrenatalTest data={form.data} patientData={patientData} />;
//           break;
//         case 'TherapyAllotment':
//           formComponent = <TherapyAllotment data={form.data} patientData={patientData} />;
//           break;
//         case 'VideoUploaded':
//           formComponent = <VideoUploaded data={form.data} patientData={patientData} />;
//           break;
//         case 'ReportSubmission':
//           formComponent = <ReportSubmission data={form.data} patientData={patientData} />;
//           break;
//         case 'CorrectedReportSupervisor':
//           formComponent = <CorrectedReportSupervisor data={form.data} patientData={patientData} />;
//           break;
//         case 'PaymentForm':
//           formComponent = <PaymentForm data={form.data} patientData={patientData} />;
//           break;
//         default:
//           formComponent = <Alert severity="warning">Form type "{form.form_type}" not supported for editing</Alert>;
//       }

//       setSelectedForm(formComponent);
//     } catch (error) {
//       console.error('Error loading previous form:', error);
//       setError('Failed to load form data');
//     } finally {
//       setFormsLoading(false);
//     }
//   };

//   const handleBackToRegister = () => {
//     navigate('/register');
//   };

//   const refreshForms = () => {
//     if (patientData?.id) {
//       fetchPatientForms(patientData.id);
//     }
//   };

//   const therapyButtons = {
//     Audiology: [
//       {
//         label: "Case History",
//         type: "dropdown",
//         options: [
//           { label: "Adult", component: <CaseHistoryAdult patientData={patientData} /> },
//           { label: "Child", component: <CaseHistoryChild patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Hearing Evaluation",
//         type: "dropdown",
//         options: [
//           { label: "Adult", component: <HearingEvaluationAdult patientData={patientData} /> },
//           { label: "Child", component: <HearingEvaluationChild patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Hearing Aid",
//         type: "dropdown",
//         options: [
//           { label: "Hearing Aid Trial", component: <HearingAidTraining patientData={patientData} /> },
//           { label: "Hearing Aid Programming", component: <ProcuringHearingAid patientData={patientData} /> },
//           { label: "Hearing Aid Followup", component: <HearingFollow patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Cochlear",
//         type: "dropdown",
//         options: [
//           { label: "Demographic", component: <Demographic patientData={patientData} /> },
//           { label: "IntraOp", component: <IntraOp patientData={patientData} /> },
//           { label: "Switch on", component: <SwitchOn patientData={patientData} /> },
//           { label: "Mapping", component: <Mapping patientData={patientData} /> },
//           { label: "Outcome", component: <OutCome patientData={patientData} /> }
//         ]
//       },
//       {
//         label: "Prenatal",
//         type: "dropdown",
//         options: [
//           { label: "Prenatal History", component: <PrenatalHistory patientData={patientData} /> },
//           { label: "Prenatal Tests", component: <PrenatalTest patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Tinnitus",
//         type: "flat",
//         component: <Tinnitus patientData={patientData} />
//       },
//       {
//         label: "LTU",
//         type: "dropdown",
//         options: [
//           { label: "Therapy Allotment", component: <TherapyAllotment patientData={patientData} /> },
//           { label: "Video Uploaded", component: <VideoUploaded patientData={patientData} /> },
//           { label: "Report Submission", component: <ReportSubmission patientData={patientData} /> },
//           { label: "Corrected Report Supervisor", component: <CorrectedReportSupervisor patientData={patientData} /> },
//         ]
//       },
//       {
//         label: "Hypercusis",
//         type: "flat",
//         component: <Hypercusis patientData={patientData} />
//       },
//       {
//         label: "Vestibular Assessment",
//         type: "flat",
//         component: <VestibularForm patientData={patientData} />
//       }
//     ],
//     Speech: [
//       { label: "Case History", type: "flat", component: <CaseHistoryAdult patientData={patientData} /> },
//       { label: "Evaluation", type: "flat", component: <div>Evaluation Form</div> },
//       { label: "Therapy", type: "flat", component: <div>Therapy Form</div> },
//       { label: "Follow Up", type: "flat", component: <div>Follow Up Form</div> },
//     ]
//   };

//   const nonTherapyDepartments = ["Outreach", "GHWC", "School Screening", "NBHS", "Payment"];

//   // Check if department is internal (Audiology or Speech)
//   const isInternalDepartment = ["Audiology", "Speech"].includes(department);
//   // Check if department is non-therapy (outside forms)
//   const isNonTherapyDepartment = nonTherapyDepartments.includes(department);

//   // If no patient data found, show error and option to go back
//   if (!patientData && !loading) {
//     return (
//       <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
//         <Alert
//           severity="error"
//           action={
//             <Button color="inherit" size="small" onClick={handleBackToRegister}>
//               Go to Registration
//             </Button>
//           }
//         >
//           No patient data found. Please register or revisit a patient first.
//         </Alert>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xxl" sx={{ mt: 3, mb: 4 }}>
//       {error && (
//         <Alert severity="error" sx={{ mb: 2 }}>
//           {error}
//         </Alert>
//       )}

//       <Paper elevation={3} sx={{ display: "flex", minHeight: 600, p: 3 }}>
//         {/* Left Panel - Inventory - ONLY SHOW FOR INTERNAL DEPARTMENTS */}
//         {isInternalDepartment && (
//           <Box sx={{ width: 350, pr: 3, borderRight: "1px solid #ccc" }}>
//             <Card elevation={1} sx={{ bgcolor: "#f9fafc", borderRadius: 2 }}>
//               <CardContent>
//                 <Typography variant="h6" sx={{ mb: 2, color: "#0d1b2a" }}>
//                   Patient Record
//                 </Typography>

//                 {loading ? (
//                   <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//                     <CircularProgress />
//                   </Box>
//                 ) : patientData ? (
//                   <>
//                     {/* Clinic Number Display */}
//                     <Box sx={{ mb: 2, p: 1.5, bgcolor: '#e8f4fd', borderRadius: 1 }}>
//                       <Typography variant="subtitle2" color="primary" gutterBottom>
//                         Clinic Number
//                       </Typography>
//                       <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//                         {patientData.ip_number || patientData.op_number || "Not Assigned"}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {patientData.ip_number ? "IP Number" : "OP Number"}
//                       </Typography>
//                     </Box>

//                     {/* Patient Information */}
//                     <Box sx={{ mt: 2, mb: 3 }}>
//                       <Typography variant="subtitle2" sx={{ mb: 1, color: "#0d1b2a" }}>
//                         Patient Information
//                       </Typography>
//                       <Box sx={{ display: 'grid', gap: 1 }}>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                           <Typography variant="body2" color="text.secondary">Name:</Typography>
//                           <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                             {patientData.name || "N/A"}
//                           </Typography>
//                         </Box>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                           <Typography variant="body2" color="text.secondary">Age:</Typography>
//                           <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                             {patientData.age || "N/A"}
//                           </Typography>
//                         </Box>

//                         <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                           <Typography variant="body2" color="text.secondary">Phone:</Typography>
//                           <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                             {patientData.phone || "N/A"}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Box>

//                     {/* Forms Section */}
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, mb: 1 }}>
//                       <Typography variant="subtitle2" sx={{ color: "#0d1b2a" }}>
//                         Clinical Forms
//                       </Typography>
//                       <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                         <Chip
//                           label={`${patientForms.length} forms`}
//                           size="small"
//                           color={patientForms.length > 0 ? "primary" : "default"}
//                           variant="outlined"
//                         />
//                         <Button
//                           size="small"
//                           onClick={refreshForms}
//                           disabled={formsLoading}
//                           variant="outlined"
//                         >
//                           {formsLoading ? <CircularProgress size={16} /> : 'Refresh'}
//                         </Button>
//                       </Box>
//                     </Box>

//                     {formsLoading ? (
//                       <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
//                         <CircularProgress size={24} />
//                       </Box>
//                     ) : (
//                       <>
//                         {patientForms.length > 0 ? (
//                           <Paper variant="outlined" sx={{ maxHeight: 300, overflow: 'auto' }}>
//                             <List dense>
//                               {patientForms.map((form, index) => (
//                                 <ListItem
//                                   key={index}
//                                   button
//                                   onClick={() => loadPreviousForm(form)}
//                                   sx={{
//                                     mb: 0.5,
//                                     borderRadius: 1,
//                                     borderLeft: '3px solid',
//                                     borderLeftColor: 'primary.main',
//                                     '&:hover': {
//                                       backgroundColor: '#e3f2fd',
//                                       transform: 'translateX(2px)'
//                                     },
//                                     transition: 'all 0.2s'
//                                   }}
//                                 >
//                                   <ListItemText
//                                     primary={
//                                       <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                                         {getFormLabel(form.form_type)}
//                                       </Typography>
//                                     }
//                                     secondary={
//                                       <Typography variant="caption" color="text.secondary">
//                                         {new Date(form.created_at).toLocaleDateString()} •
//                                         {new Date(form.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//                                       </Typography>
//                                     }
//                                   />
//                                 </ListItem>
//                               ))}
//                             </List>
//                           </Paper>
//                         ) : (
//                           <Box sx={{
//                             textAlign: 'center',
//                             py: 3,
//                             border: '1px dashed #ddd',
//                             borderRadius: 1,
//                             bgcolor: '#fafafa'
//                           }}>
//                             <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                               No forms submitted yet for this patient
//                             </Typography>
//                             <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
//                               Start by selecting a form from the menu
//                             </Typography>
//                             <Button
//                               variant="outlined"
//                               size="small"
//                               onClick={() => {
//                                 // Select the first form in the menu
//                                 const firstTab = therapyButtons[department]?.[0];
//                                 if (firstTab) {
//                                   if (firstTab.type === "dropdown") {
//                                     // Handle dropdown forms
//                                     if (firstTab.options?.[0]) {
//                                       handleOptionSelect(firstTab.options[0]);
//                                     }
//                                   } else {
//                                     setSelectedForm(React.cloneElement(firstTab.component, { patientData }));
//                                   }
//                                 }
//                               }}
//                               sx={{ mt: 1 }}
//                             >
//                               Start New Form
//                             </Button>
//                           </Box>
//                         )}
//                       </>
//                     )}

//                     {/* Debug Info */}
//                     <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #eee' }}>
//                       <Typography variant="caption" color="text.secondary">
//                         Patient ID: {patientData.id || "N/A"}
//                       </Typography>
//                       <br />
//                       <Typography variant="caption" color="text.secondary">
//                         Clinic No: {patientData.ip_number || patientData.op_number || "Not Assigned"}
//                       </Typography>
//                     </Box>
//                   </>
//                 ) : (
//                   <Box sx={{ textAlign: 'center', py: 4 }}>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                       No patient data available
//                     </Typography>
//                     <Button
//                       variant="contained"
//                       size="small"
//                       onClick={handleBackToRegister}
//                     >
//                       Register Patient
//                     </Button>
//                   </Box>
//                 )}
//               </CardContent>
//             </Card>
//           </Box>
//         )}

//         {/* Right Panel - Form Display */}
//         <Box sx={{
//           flexGrow: 1,
//           pl: isInternalDepartment ? 3 : 0,
//           width: isNonTherapyDepartment ? '100%' : 'auto'
//         }}>
//           <Typography variant="h4" align="center" sx={{ mb: 2, color: "primary.main" }}>
//             {patientData ? `Clinical Forms` : 'Clinical Forms'}
//           </Typography>

//           {isNonTherapyDepartment && selectedForm && (
//             <Box sx={{ width: '100%' }}>
//               {formsLoading ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
//                   <CircularProgress />
//                 </Box>
//               ) : (
//                 selectedForm
//               )}
//             </Box>
//           )}

//           {isInternalDepartment && patientData && (
//             <>
//               <Tabs
//                 value={activeTab}
//                 onChange={(e, newValue) => setActiveTab(newValue)}
//                 variant="scrollable"
//                 scrollButtons="auto"
//                 sx={{ mb: 2 }}
//               >
//                 {therapyButtons[department]?.map((button, index) => (
//                   <Tab
//                     key={index}
//                     label={button.label}
//                     onClick={(e) => {
//                       if (button.type === "dropdown") {
//                         handleDropdownOpen(e, button);
//                       } else {
//                         setSelectedForm(React.cloneElement(button.component, { patientData }));
//                       }
//                     }}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       mx: 1,
//                       px: 3,
//                       borderRadius: "30px",
//                       backgroundColor: activeTab === index ? "#0d1b2a" : "#e8ecf1",
//                       color: activeTab === index ? "#ffffff" : "#0d1b2a",
//                       "&:hover": {
//                         backgroundColor: "#16293f",
//                         color: "#ffffff",
//                       },
//                     }}
//                   />
//                 ))}
//               </Tabs>

//               <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
//                 {currentDropdown?.options?.map((option, idx) => (
//                   <MenuItem key={idx} onClick={() => handleOptionSelect(option)}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Menu>

//               <Box sx={{ mt: 2, border: "1px solid #e0e0e0", borderRadius: 2, p: 3, minHeight: 520, width: '93%' }}>
//                 {formsLoading ? (
//                   <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
//                     <CircularProgress />
//                   </Box>
//                 ) : selectedForm ? (
//                   selectedForm
//                 ) : (
//                   <Typography variant="body1" align="center" sx={{ color: "text.secondary", mt: 8 }}>
//                     Select a form from the menu above to begin
//                   </Typography>
//                 )}
//               </Box>
//             </>
//           )}

//           {!isInternalDepartment && !isNonTherapyDepartment && patientData && (
//             <Box sx={{ textAlign: 'center', mt: 8 }}>
//               <Typography variant="h6" color="text.secondary">
//                 No department selected or department not recognized
//               </Typography>
//               <Button
//                 variant="contained"
//                 onClick={handleBackToRegister}
//                 sx={{ mt: 2 }}
//               >
//                 Select Department
//               </Button>
//             </Box>
//           )}
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default Demography;
import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  Menu,
  MenuItem,
  Paper,
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
  CircularProgress,
  Alert,
  Button,
  Chip
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

// Import therapy components
import CaseHistoryAdult from "../components/CaseHistoryAdult";
import CaseHistoryChild from "../components/CaseHistoryChild";
import HearingEvaluationAdult from "../components/HearingEvaluationAdult";
import HearingEvaluationChild from "../components/HearingEvaluationChild";
import HearingAidTraining from "../components/HearingAidTraining";
import ProcuringHearingAid from "../components/ProcuringHearingAid";
import HearingFollow from "../components/HearingFollow";
import ListeningTrainingUnit from "../components/ListeningTrainingUnit";
import OutReach from "../components/OutReach";
import SchoolScreeningForm from "../components/SchoolScreeningForm";
import Hypercusis from "../components/Hypercusis";
import Tinnitus from "../components/Tinnitus";
import VestibularForm from "../components/VestibularForm";
import HearingWellness from "../components/HearingWelness";
import NewbornForm from "../components/NewbornForm";
import Cochlear from "../components/Cochlear";
import Demographic from "../components/Demographic";
import IntraOp from "../components/IntraOp";
import SwitchOn from "../components/SwitchOn";
import Mapping from "../components/Mapping";
import OutCome from "../components/OutCome";
import PrenatalHistory from "../components/PrenatalHistory";
import PrenatalTest from "../components/PrenatalTest";
import TherapyAllotment from "../components/TherapyAllotment";
import VideoUploaded from "../components/VideoUploaded";
import ReportSubmission from "../components/ReportSubmission";
import CorrectedReportSupervisor from "../components/CorrectedReportSupervisor";
import PaymentForm from "../components/PaymentForm";

const Demography = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [patientData, setPatientData] = useState(null);
  const [patientForms, setPatientForms] = useState([]);
  const [error, setError] = useState("");
  const [department, setDepartment] = useState("");
  const [selectedForm, setSelectedForm] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentDropdown, setCurrentDropdown] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formsLoading, setFormsLoading] = useState(false);

  const nonTherapyDepartments = ["Outreach", "GHWC", "School Screening", "NBHS", "Payment"];

  useEffect(() => {
    // Get department from localStorage
    const savedDepartment = localStorage.getItem("department");
    if (savedDepartment) {
      setDepartment(savedDepartment);
      // we will auto-select non-therapy forms after patientData loads
    }

    // Fetch patient data
    fetchPatientData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // When both department and patientData are available, auto-select non-therapy forms (if applicable)
  useEffect(() => {
    if (department && patientData && nonTherapyDepartments.includes(department)) {
      handleFormSelect(department);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [department, patientData]);

  const normalize = (v) => {
    if (v === null || v === undefined) return "";
    return String(v).trim();
  };

  /**
   * Centralized function to check whether a given form belongs to the patient.
   * This checks many common field names and nested shapes.
   */
  const matchesPatient = (form, patient) => {
    if (!form || !patient) return false;

    const patientId = normalize(patient.id);
    const clinicNumbers = [patient.ip_number, patient.op_number]
      .filter(Boolean)
      .map(x => normalize(x));

    // collect form-side possible patient/id/clinic fields
    const candidates = [];

    // common top-level ids
    candidates.push(normalize(form.patient_id));
    candidates.push(normalize(form.patientId));
    candidates.push(normalize(form.patient));
    candidates.push(normalize(form.patient_id_fk));
    candidates.push(normalize(form.patientIdFk));

    // nested patient object
    if (form.patient && typeof form.patient === "object") {
      candidates.push(normalize(form.patient.id));
      candidates.push(normalize(form.patient.patient_id));
      candidates.push(normalize(form.patient.op_number));
      candidates.push(normalize(form.patient.ip_number));
    }

    // clinic-like fields
    const clinicCandidates = [
      normalize(form.op_number),
      normalize(form.opNumber),
      normalize(form.opNo),
      normalize(form.op),
      normalize(form.ip_number),
      normalize(form.ipNumber),
      normalize(form.ipNo),
      normalize(form.ip),
      normalize(form.clinic_number),
      normalize(form.clinicNo),
      normalize(form.clinic),
      normalize(form.clinicNo),
      normalize(form.clinicNumber),
      normalize(form.meta && form.meta.clinic),
      normalize(form.metadata && form.metadata.clinic),
    ].filter(Boolean);

    // 1) match by patient id if available
    if (patientId) {
      for (let c of candidates) {
        if (c && c === patientId) return true;
      }
    }

    // 2) match by clinic numbers (OP/IP)
    if (clinicNumbers.length && clinicCandidates.length) {
      for (let cn of clinicNumbers) {
        for (let fc of clinicCandidates) {
          if (!fc) continue;
          // exact match
          if (fc === cn) return true;
          // sometimes stored with prefixes/suffixes, check includes
          if (fc.includes(cn) || cn.includes(fc)) return true;
        }
      }
    }

    // 3) last attempt: check if created_by or other nested fields reference the clinic number
    const otherPlaces = [
      normalize(form.created_by),
      normalize(form.createdBy),
      normalize(form.source),
      normalize(form.origin)
    ].filter(Boolean);

    for (let op of otherPlaces) {
      for (let cn of clinicNumbers) {
        if (op.includes(cn) || cn.includes(op)) return true;
      }
    }

    return false;
  };

  const fetchPatientData = async () => {
    try {
      setLoading(true);
      setError("");

      // Get patient data from localStorage (set during registration or revisit)
      const savedPatientData = localStorage.getItem("demography");

      if (!savedPatientData) {
        // If no patient data in localStorage, check if we have a patient ID from revisit
        const revisitPatientId = localStorage.getItem("revisitPatientId");
        if (revisitPatientId) {
          await fetchPatientById(revisitPatientId);
        } else {
          setError("No patient data found. Please register or revisit a patient first.");
          setLoading(false);
        }
        return;
      }

      const patient = JSON.parse(savedPatientData);
      console.log("📄 Patient data from localStorage:", patient);
      setPatientData(patient);

      // Fetch forms for this patient (pass full patient object)
      await fetchPatientForms(patient);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      setError("Failed to load patient data");
    } finally {
      setLoading(false);
    }
  };

  const fetchPatientById = async (patientId) => {
    try {
      console.log("🔄 Fetching patient by ID:", patientId);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/patients/${patientId}`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: Failed to fetch patient data`);
      }

      const patient = await response.json();
      console.log("📄 Patient data from API:", patient);

      // Save to localStorage for consistency
      localStorage.setItem('demography', JSON.stringify(patient));
      setPatientData(patient);

      // Fetch forms for this patient (pass full patient object)
      await fetchPatientForms(patient);
    } catch (error) {
      console.error('❌ Error fetching patient:', error);
      setError("Failed to load patient data: " + error.message);
    }
  };


   const fetchPatientForms = async (patient) => {
    try {
      setFormsLoading(true);
      console.log("🔄 Fetching forms for patient:", patient);

      if (!patient) {
        console.error("❌ No patient provided to fetchPatientForms");
        setPatientForms([]);
        return;
      }

      const patientId = patient.id ? normalize(patient.id) : "";
      const clinicNumbers = [patient.ip_number, patient.op_number]
        .filter(Boolean)
        .map(x => normalize(x));

      // build endpoints to try in order
      const tryEndpoints = [];

      if (patientId) {
        tryEndpoints.push(`${process.env.REACT_APP_API_URL}/api/patient-forms/${encodeURIComponent(patientId)}`);
      }

      if (clinicNumbers.length) {
        // try common query names - adapt if your backend uses specific query keys
        // try op_number and ip_number as explicit queries
        clinicNumbers.forEach(cn => {
          tryEndpoints.push(`${process.env.REACT_APP_API_URL}/api/patient-forms?op_number=${encodeURIComponent(cn)}`);
          tryEndpoints.push(`${process.env.REACT_APP_API_URL}/api/patient-forms?ip_number=${encodeURIComponent(cn)}`);
          tryEndpoints.push(`${process.env.REACT_APP_API_URL}/api/patient-forms?clinic=${encodeURIComponent(cn)}`);
        });
      }

      // final fallback: fetch all and filter client side
      tryEndpoints.push(`${process.env.REACT_APP_API_URL}/api/patient-forms`);

      let allForms = [];
      let success = false;

      for (let url of tryEndpoints) {
        try {
          console.log("➡️ Trying forms endpoint:", url);
          const res = await fetch(url);

          if (!res.ok) {
            console.warn(`Endpoint ${url} returned ${res.status}`);
            // continue to next endpoint
            continue;
          }

          let forms = await res.json();
          if (!forms) {
            continue;
          }

          // Normalize shapes: unwrap { data: [...] } if present
          if (!Array.isArray(forms)) {
            if (Array.isArray(forms.data)) {
              forms = forms.data;
            } else {
              forms = [forms];
            }
          }

          console.log(`🔁 Received ${forms.length} forms from ${url}`);
          // accumulate
          allForms = allForms.concat(forms);

          // Basic heuristic: if endpoint was a patientId-specific endpoint, we can stop trying others
          if (url.includes(`/api/patient-forms/${encodeURIComponent(patientId)}`) && forms.length > 0) {
            success = true;
            break;
          }

          // If we got forms from clinic-specific queries, prefer those
          if ((url.includes("op_number=") || url.includes("ip_number=") || url.includes("clinic=")) && forms.length > 0) {
            success = true;
            break;
          }

          // otherwise continue to next endpoint to gather more or find a better match
        } catch (err) {
          console.error("Fetch error for", url, err);
          // try next endpoint
        }
      }

      // dedupe forms by unique id or JSON string (best-effort)
      const deduped = [];
      const seen = new Set();
      allForms.forEach(f => {
        const key = normalize(f.id) || JSON.stringify(f);
        if (!seen.has(key)) {
          seen.add(key);
          deduped.push(f);
        }
      });

      console.log("📋 Total forms gathered (deduped):", deduped.length, deduped);

      // Filter forms that match patient using matchesPatient
      const filtered = deduped.filter(f => matchesPatient(f, patient));

      console.log("📋 Forms after filtering (for this patient):", filtered.length, filtered);

      // If we found none via the earlier endpoints but patient has clinicnumbers,
      // do a last-resort client-side filter of deduped (already done). But also log for debugging.
      if (filtered.length === 0 && clinicNumbers.length > 0) {
        console.warn("No forms matched after filtering. Possible causes:");
        console.warn(" - Server returns forms under different field names (inspect 'deduped' above)");
        console.warn(" - Clinic number format mismatch (string vs number).");
        console.warn("Deduped forms preview:", deduped.slice(0, 10));
      }

      setPatientForms(filtered);
    } catch (error) {
      console.error('❌ Network error fetching patient forms:', error);
      setPatientForms([]);
    } finally {
      setFormsLoading(false);
    }
  };

  const handleFormSelect = (formName) => {
    // Create form with patient data
    const createFormWithPatientData = (Component) => {
      return React.createElement(Component, { patientData });
    };

    switch (formName) {
      case "Outreach":
        setSelectedForm(createFormWithPatientData(OutReach));
        break;
      case "School Screening":
        setSelectedForm(createFormWithPatientData(SchoolScreeningForm));
        break;
      case "GHWC":
        setSelectedForm(createFormWithPatientData(HearingWellness));
        break;
      case "NBHS":
        setSelectedForm(createFormWithPatientData(NewbornForm));
        break;
      case "Tinnitus":
        setSelectedForm(createFormWithPatientData(Tinnitus));
        break;
      case "LTU":
        setSelectedForm(createFormWithPatientData(ListeningTrainingUnit));
        break;
      case "Hypercusis":
        setSelectedForm(createFormWithPatientData(Hypercusis));
        break;
      case "Vestibular Assessment":
        setSelectedForm(createFormWithPatientData(VestibularForm));
        break;
      case "Cochlear":
        setSelectedForm(createFormWithPatientData(Cochlear));
        break;
      case "Payment":
        setSelectedForm(createFormWithPatientData(PaymentForm));
        break;
      default:
        setSelectedForm(null);
    }
  };

  const handleOptionSelect = (option) => {
    // Create form component with patient data
    const formWithPatientData = React.cloneElement(option.component, { patientData });
    setSelectedForm(formWithPatientData);
    setAnchorEl(null);
    setCurrentDropdown(null);
  };

  const handleDropdownOpen = (event, dropdown) => {
    setAnchorEl(event.currentTarget);
    setCurrentDropdown(dropdown);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentDropdown(null);
  };

  const getFormLabel = (formType) => {
    const formLabels = {
      'CaseHistoryAdult': 'Case History (Adult)',
      'CaseHistoryChild': 'Case History (Child)',
      'Tinnitus': 'Tinnitus',
      'Hyperacusis': 'Hyperacusis',
      'ListeningTrainingUnit': 'Listening Training Unit',
      'HearingEvaluationAdult': 'Hearing Evaluation (Adult)',
      'HearingEvaluationChild': 'Hearing Evaluation (Child)',
      'HearingAidTraining': 'Hearing Aid Training',
      'ProcuringHearingAid': 'Procuring Hearing Aid',
      'HearingFollow': 'Hearing Follow-up',
      'Outreach': 'Outreach',
      'SchoolScreening': 'School Screening',
      'HearingWellness': 'Hearing Wellness',
      'Newborn': 'Newborn Screening',
      'Vestibular': 'Vestibular Assessment',
      'Demographic': 'Demographic',
      'Intraoperative': 'Intraoperative',
      'Switchon': 'Switch On',
      'Mapping': 'Mapping',
      'Outcome': 'Outcome',
      'PrenatalHistory': 'Prenatal History',
      'PrenatalTests': 'Prenatal Tests',
      'TherapyAllotment': 'Therapy Allotment',
      'VideoUploaded': 'Video Upload',
      'ReportSubmission': 'Report Submission',
      'CorrectedReportSupervisor': 'Corrected Report',
      'PaymentForm': 'Payment Form'
    };

    return formLabels[formType] || formType;
  };

  const loadPreviousForm = async (form) => {
    try {
      setFormsLoading(true);

      let formComponent = null;

      switch (form.form_type) {
        case 'CaseHistoryAdult':
          formComponent = <CaseHistoryAdult data={form.data} patientData={patientData} />;
          break;
        case 'CaseHistoryChild':
          formComponent = <CaseHistoryChild data={form.data} patientData={patientData} />;
          break;
        case 'Tinnitus':
          formComponent = <Tinnitus data={form.data} patientData={patientData} />;
          break;
        case 'Hyperacusis':
          formComponent = <Hypercusis data={form.data} patientData={patientData} />;
          break;
        case 'ListeningTrainingUnit':
          formComponent = <ListeningTrainingUnit data={form.data} patientData={patientData} />;
          break;
        case 'HearingEvaluationAdult':
          formComponent = <HearingEvaluationAdult data={form.data} patientData={patientData} />;
          break;
        case 'HearingEvaluationChild':
          formComponent = <HearingEvaluationChild data={form.data} patientData={patientData} />;
          break;
        case 'HearingAidTraining':
          formComponent = <HearingAidTraining data={form.data} patientData={patientData} />;
          break;
        case 'ProcuringHearingAid':
          formComponent = <ProcuringHearingAid data={form.data} patientData={patientData} />;
          break;
        case 'HearingFollow':
          formComponent = <HearingFollow data={form.data} patientData={patientData} />;
          break;
        case 'Outreach':
          formComponent = <OutReach data={form.data} patientData={patientData} />;
          break;
        case 'SchoolScreening':
          formComponent = <SchoolScreeningForm data={form.data} patientData={patientData} />;
          break;
        case 'HearingWellness':
          formComponent = <HearingWellness data={form.data} patientData={patientData} />;
          break;
        case 'Newborn':
          formComponent = <NewbornForm data={form.data} patientData={patientData} />;
          break;
        case 'Vestibular':
          formComponent = <VestibularForm data={form.data} patientData={patientData} />;
          break;
        case 'Demographic':
          formComponent = <Demographic data={form.data} patientData={patientData} />;
          break;
        case 'Intraoperative':
          formComponent = <IntraOp data={form.data} patientData={patientData} />;
          break;
        case 'Switchon':
          formComponent = <SwitchOn data={form.data} patientData={patientData} />;
          break;
        case 'Mapping':
          formComponent = <Mapping data={form.data} patientData={patientData} />;
          break;
        case 'Outcome':
          formComponent = <OutCome data={form.data} patientData={patientData} />;
          break;
        case 'PrenatalHistory':
          formComponent = <PrenatalHistory data={form.data} patientData={patientData} />;
          break;
        case 'PrenatalTests':
          formComponent = <PrenatalTest data={form.data} patientData={patientData} />;
          break;
        case 'TherapyAllotment':
          formComponent = <TherapyAllotment data={form.data} patientData={patientData} />;
          break;
        case 'VideoUploaded':
          formComponent = <VideoUploaded data={form.data} patientData={patientData} />;
          break;
        case 'ReportSubmission':
          formComponent = <ReportSubmission data={form.data} patientData={patientData} />;
          break;
        case 'CorrectedReportSupervisor':
          formComponent = <CorrectedReportSupervisor data={form.data} patientData={patientData} />;
          break;
        case 'PaymentForm':
          formComponent = <PaymentForm data={form.data} patientData={patientData} />;
          break;
        default:
          formComponent = <Alert severity="warning">Form type "{form.form_type}" not supported for editing</Alert>;
      }

      setSelectedForm(formComponent);
    } catch (error) {
      console.error('Error loading previous form:', error);
      setError('Failed to load form data');
    } finally {
      setFormsLoading(false);
    }
  };

  const handleBackToRegister = () => {
    navigate('/register');
  };

  const refreshForms = () => {
    if (patientData) {
      fetchPatientForms(patientData);
    }
  };

  const therapyButtons = {
    Audiology: [
      {
        label: "Case History",
        type: "dropdown",
        options: [
          { label: "Adult", component: <CaseHistoryAdult patientData={patientData} /> },
          { label: "Child", component: <CaseHistoryChild patientData={patientData} /> },
        ]
      },
      {
        label: "Hearing Evaluation",
        type: "dropdown",
        options: [
          { label: "Adult", component: <HearingEvaluationAdult patientData={patientData} /> },
          { label: "Child", component: <HearingEvaluationChild patientData={patientData} /> },
        ]
      },
      {
        label: "Hearing Aid",
        type: "dropdown",
        options: [
          { label: "Hearing Aid Trial", component: <HearingAidTraining patientData={patientData} /> },
          { label: "Hearing Aid Programming", component: <ProcuringHearingAid patientData={patientData} /> },
          { label: "Hearing Aid Followup", component: <HearingFollow patientData={patientData} /> },
        ]
      },
      {
        label: "Cochlear",
        type: "dropdown",
        options: [
          { label: "Demographic", component: <Demographic patientData={patientData} /> },
          { label: "IntraOp", component: <IntraOp patientData={patientData} /> },
          { label: "Switch on", component: <SwitchOn patientData={patientData} /> },
          { label: "Mapping", component: <Mapping patientData={patientData} /> },
          { label: "Outcome", component: <OutCome patientData={patientData} /> }
        ]
      },
      {
        label: "Prenatal",
        type: "dropdown",
        options: [
          { label: "Prenatal History", component: <PrenatalHistory patientData={patientData} /> },
          { label: "Prenatal Tests", component: <PrenatalTest patientData={patientData} /> },
        ]
      },
      {
        label: "Tinnitus",
        type: "flat",
        component: <Tinnitus patientData={patientData} />
      },
      {
        label: "LTU",
        type: "dropdown",
        options: [
          { label: "Therapy Allotment", component: <TherapyAllotment patientData={patientData} /> },
          { label: "Video Uploaded", component: <VideoUploaded patientData={patientData} /> },
          { label: "Report Submission", component: <ReportSubmission patientData={patientData} /> },
          { label: "Corrected Report Supervisor", component: <CorrectedReportSupervisor patientData={patientData} /> },
        ]
      },
      {
        label: "Hypercusis",
        type: "flat",
        component: <Hypercusis patientData={patientData} />
      },
      {
        label: "Vestibular Assessment",
        type: "flat",
        component: <VestibularForm patientData={patientData} />
      }
    ],
    Speech: [
      { label: "Case History", type: "flat", component: <CaseHistoryAdult patientData={patientData} /> },
      { label: "Evaluation", type: "flat", component: <div>Evaluation Form</div> },
      { label: "Therapy", type: "flat", component: <div>Therapy Form</div> },
      { label: "Follow Up", type: "flat", component: <div>Follow Up Form</div> },
    ]
  };

  // Check if department is internal (Audiology or Speech)
  const isInternalDepartment = ["Audiology", "Speech"].includes(department);
  // Check if department is non-therapy (outside forms)
  const isNonTherapyDepartment = nonTherapyDepartments.includes(department);

  // If no patient data found, show error and option to go back
  if (!patientData && !loading) {
    return (
      <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={handleBackToRegister}>
              Go to Registration
            </Button>
          }
        >
          No patient data found. Please register or revisit a patient first.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="xxl" sx={{ mt: 3, mb: 4 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Paper elevation={3} sx={{ display: "flex", minHeight: 600, p: 3 }}>
        {/* Left Panel - Inventory - ONLY SHOW FOR INTERNAL DEPARTMENTS */}
        {isInternalDepartment && (
          <Box sx={{ width: 350, pr: 3, borderRight: "1px solid #ccc" }}>
            <Card elevation={1} sx={{ bgcolor: "#f9fafc", borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, color: "#0d1b2a" }}>
                  Patient Record
                </Typography>

                {loading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                    <CircularProgress />
                  </Box>
                ) : patientData ? (
                  <>
                    {/* Clinic Number Display */}
                    <Box sx={{ mb: 2, p: 1.5, bgcolor: '#e8f4fd', borderRadius: 1 }}>
                      <Typography variant="subtitle2" color="primary" gutterBottom>
                        Clinic Number
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {patientData.ip_number || patientData.op_number || "Not Assigned"}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {patientData.ip_number ? "IP Number" : "OP Number"}
                      </Typography>
                    </Box>

                    {/* Patient Information */}
                    <Box sx={{ mt: 2, mb: 3 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, color: "#0d1b2a" }}>
                        Patient Information
                      </Typography>
                      <Box sx={{ display: 'grid', gap: 1 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Name:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                            {patientData.name || "N/A"}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Age:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                            {patientData.age || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Phone:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                            {patientData.phone || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Forms Section */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ color: "#0d1b2a" }}>
                        Clinical Forms
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Chip
                          label={`${patientForms.length} forms`}
                          size="small"
                          color={patientForms.length > 0 ? "primary" : "default"}
                          variant="outlined"
                        />
                        <Button
                          size="small"
                          onClick={refreshForms}
                          disabled={formsLoading}
                          variant="outlined"
                        >
                          {formsLoading ? <CircularProgress size={16} /> : 'Refresh'}
                        </Button>
                      </Box>
                    </Box>

                    {formsLoading ? (
                      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                        <CircularProgress size={24} />
                      </Box>
                    ) : (
                      <>
                        {patientForms.length > 0 ? (
                          <Paper variant="outlined" sx={{ maxHeight: 300, overflow: 'auto' }}>
                            <List dense>
                              {patientForms.map((form, index) => (
                                <ListItem
                                  key={index}
                                  button
                                  onClick={() => loadPreviousForm(form)}
                                  sx={{
                                    mb: 0.5,
                                    borderRadius: 1,
                                    borderLeft: '3px solid',
                                    borderLeftColor: 'primary.main',
                                    '&:hover': {
                                      backgroundColor: '#e3f2fd',
                                      transform: 'translateX(2px)'
                                    },
                                    transition: 'all 0.2s'
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                        {getFormLabel(form.form_type)}
                                      </Typography>
                                    }
                                    secondary={
                                      <Typography variant="caption" color="text.secondary">
                                        {form.created_at ? new Date(form.created_at).toLocaleDateString() + " • " +
                                        new Date(form.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "No timestamp"}
                                      </Typography>
                                    }
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Paper>
                        ) : (
                          <Box sx={{
                            textAlign: 'center',
                            py: 3,
                            border: '1px dashed #ddd',
                            borderRadius: 1,
                            bgcolor: '#fafafa'
                          }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              No forms submitted yet for this patient
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                              Start by selecting a form from the menu
                            </Typography>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => {
                                // Select the first form in the menu
                                const firstTab = therapyButtons[department]?.[0];
                                if (firstTab) {
                                  if (firstTab.type === "dropdown") {
                                    // Handle dropdown forms
                                    if (firstTab.options?.[0]) {
                                      handleOptionSelect(firstTab.options[0]);
                                    }
                                  } else {
                                    setSelectedForm(React.cloneElement(firstTab.component, { patientData }));
                                  }
                                }
                              }}
                              sx={{ mt: 1 }}
                            >
                              Start New Form
                            </Button>
                          </Box>
                        )}
                      </>
                    )}

                    {/* Debug Info */}
                    <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #eee' }}>
                      <Typography variant="caption" color="text.secondary">
                        Patient ID: {patientData.id || "N/A"}
                      </Typography>
                      <br />
                      <Typography variant="caption" color="text.secondary">
                        Clinic No: {patientData.ip_number || patientData.op_number || "Not Assigned"}
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      No patient data available
                    </Typography>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleBackToRegister}
                    >
                      Register Patient
                    </Button>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Box>
        )}

        {/* Right Panel - Form Display */}
        <Box sx={{
          flexGrow: 1,
          pl: isInternalDepartment ? 3 : 0,
          width: isNonTherapyDepartment ? '100%' : 'auto'
        }}>
          <Typography variant="h4" align="center" sx={{ mb: 2, color: "primary.main" }}>
            {patientData ? `Clinical Forms` : 'Clinical Forms'}
          </Typography>

          {isNonTherapyDepartment && selectedForm && (
            <Box sx={{ width: '100%' }}>
              {formsLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
                  <CircularProgress />
                </Box>
              ) : (
                selectedForm
              )}
            </Box>
          )}

          {isInternalDepartment && patientData && (
            <>
              <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ mb: 2 }}
              >
                {therapyButtons[department]?.map((button, index) => (
                  <Tab
                    key={index}
                    label={button.label}
                    onClick={(e) => {
                      if (button.type === "dropdown") {
                        handleDropdownOpen(e, button);
                      } else {
                        setSelectedForm(React.cloneElement(button.component, { patientData }));
                      }
                    }}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "0.9rem",
                      mx: 1,
                      px: 3,
                      borderRadius: "30px",
                      backgroundColor: activeTab === index ? "#0d1b2a" : "#e8ecf1",
                      color: activeTab === index ? "#ffffff" : "#0d1b2a",
                      "&:hover": {
                        backgroundColor: "#16293f",
                        color: "#ffffff",
                      },
                    }}
                  />
                )) || null}
              </Tabs>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                {currentDropdown?.options?.map((option, idx) => (
                  <MenuItem key={idx} onClick={() => handleOptionSelect(option)}>
                    {option.label}
                  </MenuItem>
                )) || null}
              </Menu>

              <Box sx={{ mt: 2, border: "1px solid #e0e0e0", borderRadius: 2, p: 3, minHeight: 520, width: '93%' }}>
                {formsLoading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                    <CircularProgress />
                  </Box>
                ) : selectedForm ? (
                  selectedForm
                ) : (
                  <Typography variant="body1" align="center" sx={{ color: "text.secondary", mt: 8 }}>
                    Select a form from the menu above to begin
                  </Typography>
                )}
              </Box>
            </>
          )}

          {!isInternalDepartment && !isNonTherapyDepartment && patientData && (
            <Box sx={{ textAlign: 'center', mt: 8 }}>
              <Typography variant="h6" color="text.secondary">
                No department selected or department not recognized
              </Typography>
              <Button
                variant="contained"
                onClick={handleBackToRegister}
                sx={{ mt: 2 }}
              >
                Select Department
              </Button>
            </Box>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default Demography;